function isValid(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, elm, attr, ctrl) {

      var regexp;

      attr.$observe('isValid', function(patternString) {

        regexp = Helper.getRegExp(patternString);

        ctrl.$validate();

      });

      ctrl.$validators.isValid = function(modelValue) {
        return ctrl.$isEmpty(modelValue) || (regexp && regexp.test(modelValue));
      };

    }
  };
}

export { isValid };
